import { MenuItens } from 'core/domains';

import { sharedConfig } from './shared';

import type { Config } from 'core/domains/config';

const { app, ...shared } = sharedConfig;

const configCatKey = process.env.REACT_APP_BOT_CONFIG_CAT_KEY || '';
const newRelicLicenseKey = process.env.REACT_APP_NEW_RELIC_LICENSE_KEY || '';
const recaptchaSecretKey = process.env.REACT_APP_RECAPTCHA_BOT_SECRET_KEY || '';
const oneTrustCookieKey = process.env.REACT_APP_BOT_ONE_TRUST_COOKIE_CONSENT_ID || '';

const configBase = {
  app: {
    basename: '/ativacao/atendimento',
    name: 'Venda Direta Interativa',
    short: 'vdi',
    staticUrl: 'http://localhost:8002',
    fallbackUrl: 'https://hvdi.venda-direta.grupoboticario.digital',
    logout: 'https://hvdi.venda-direta.grupoboticario.digital/ativacao/atendimento',
    slugname: 'vdi',
    ...app,
    url: 'https://hvdi.venda-direta.grupoboticario.digital',
  },
  acceptedCards: [],
  bff: {
    applicationID: '1efd7695-e907-4492-b6af-5bc9037b66ad',
    baseUrl: 'https://hproxy-unified-bff.venda-direta.grupoboticario.digital/',
    clientID: '3i3wkQ7jStzPxsBadl2oGodRmqUSOuaujl9R1KKSBFTeIuX0',
    getCustomHeaders: () => ({ Reseller_id: localStorage.getItem('vdi:resellerId') }),
  },
  configCat: {
    sdkKey: configCatKey,
  },
  cashbackLabel: 'Cashback',
  cashbackToolTip: false,
  communication: {
    userNamingConvention: {
      singular: 'Revendedor',
      plural: 'Revendedores',
    },
    sac: {
      openingHours: {
        week: {
          days: 'Segunda a sexta',
          hours: '8h às 20h',
        },
        weekend: {
          days: 'Sábado',
          hours: '9h às 16h',
        },
      },
      phone: '0800-729-9050',
      whatsapp: '(41) 8735-7095',
      whatsappText:
        'Olá, estava no Portal do Revendedor e gostaria de falar com a Central de Atendimento ao Revendedor O Boticário',
    },
    page401: {
      subtitle:
        'Para continuar o pedido, você precisa entrar no Portal novamente e acessar o carrinho. Não se preocupe, se você já tiver incluído itens no pedido, você poderá vê-los novamente após o login.',
    },
  },
  isAdministrateTax: false,
  google: {
    gtm: {
      containerID: 'GTM-PTQ6N9Q7',
    },
    analytics: {
      id: 'XXXXXXXX',
    },
    recaptcha: {
      secretKey: recaptchaSecretKey,
    },
  },
  pickupStore: 13,
  reseller: 13,
  retroActiveReseller: 9,
  newRelic: {
    accountID: '3160087',
    agentID: '601425425',
    licenseKey: newRelicLicenseKey,
    trustKey: '3080127',
  },
  oneTrustCookie: {
    key: oneTrustCookieKey,
  },
  prismic: {
    accessToken: '',
    apiUrl: 'https://re-boticario.cdn.prismic.io/api/v2',
    repo: 're-boticario',
  },
  seo: {
    title: 'Revendedor O Boticário',
    meta: {
      description:
        'Site exclusivo para Representante O Boticário. Faça pedidos on-line de forma rápida e prática.',
      'theme-color': '#011E38',
    },
    links: [
      {
        rel: 'icon',
        type: 'image/png',
        href: `/static/boticario/favicon.png?v=${sharedConfig.app.version}`,
      },
      {
        rel: 'apple-touch-icon',
        href: `/static/boticario/favicon192x192.png?v=${sharedConfig.app.version}`,
      },
      {
        rel: 'apple-touch-icon',
        href: `/static/boticario/favicon512x512.png?v=${sharedConfig.app.version}`,
      },
      { rel: 'manifest', href: `/static/boticario/manifest.json?v=${sharedConfig.app.version}` },
    ],
  },
  header: {
    fixed: false,
  },
  footer: {
    hidden: true,
    links: [],
    socialMediaAndApps: {
      accessibility: {
        facebookAlt: 'Acessar Facebook de O Boticário',
        instagramAlt: 'Acessar Instagram de O Boticário',
        youtubeAlt: 'Acessar Youtube de O Boticário',
      },
      appCTA: 'Baixe o Aplicativo Revendedor O Boticário',
      facebook: 'https://www.facebook.com/oboticario/',
      instagram: 'https://www.instagram.com/oboticario/',
      youtube: 'https://www.youtube.com/channel/UCBzHXqTZlKVe_aoDU5cbfRw',
      android:
        'https://play.google.com/store/apps/details?id=br.com.grupoboticario.boticariorepresentante&hl=pt_BR&gl=US&pli=1',
      ios: 'https://apps.apple.com/br/app/o-botic%C3%A1rio-revendedor/id1465675800',
    },
  },
  renegotiationSac: {
    whatsapp: '0800 745 0000',
    phone: '0800 745 0000',
    portalName: 'Regulariza Grupo Boticário',
    portalLink: 'https://regularizagrupoboticario.com.br/',
    hours: {
      whatsapp: 'Segunda a sexta, das 08h às 20h40. Sábado, das 08h às 14h20.',
      phone: 'Segunda a sexta, das 08h às 20h40. Sábado, das 08h às 14h20.',
      portal: 'Atendimento 24 horas',
    },
  },
  signup: {
    site: 'https://revenda.boticario.com.br/?utm_source=portal-revendedor&utm_medium=botao&utm_content=quero-ser-revendedor',
  },
  ...shared,
};

if (process.env.NODE_ENV === 'test') {
  configBase.configCat.sdkKey = 'hQXZCNkV8kOCePsrAgp6EQ/Wi2iC23cd0eX-Z-J4O3k1g'; //Fake Key
}

if (process.env.REACT_APP_ENV === 'staging') {
  configBase.app.url = 'https://hvdi.venda-direta.grupoboticario.digital';
  configBase.app.staticUrl = 'https://hvdi.boticario.com.br';
}

if (process.env.REACT_APP_ENV === 'production') {
  configBase.app.url = 'https://vdi.venda-direta.grupoboticario.digital';
  configBase.app.staticUrl = 'https://vdi.boticario.com.br';
  configBase.app.fallbackUrl = 'https://vdi.venda-direta.grupoboticario.digital';
  configBase.app.logout = 'https://vdi.venda-direta.grupoboticario.digital/ativacao/atendimento';
  configBase.bff.baseUrl = 'https://proxy-unified-bff.venda-direta.grupoboticario.digital/';
  configBase.bff.clientID = '2lxotPmmlHgsSujcMtEfqyS54adTge7nScAQDRTuMejjsUJG';
  configBase.bff.applicationID = '070c9bf3-9d50-4c9a-8b7a-4368eb635fcd';
  configBase.newRelic.accountID = '3160087';
  configBase.newRelic.agentID = '601406174';
  configBase.reseller = 9;
  configBase.pickupStore = 9;
}

const menuItens = {
  navBar: {
    links: [] as MenuItens['links'],
  },
};

const config: Config = { ...configBase, ...menuItens };

export default config;
